<script setup>
import styles from '@/components/styleVariables'
// import { defineProps } from 'vue'
import { useTicketStore } from '@/stores/ticket'
import { useCallWindowStore } from '@/stores/callWindow'
import { useRouter } from 'vue-router'

const router = useRouter()
const ticketStore = useTicketStore()
const callWindowStore = useCallWindowStore()
defineProps({
  ticket: {
    type: Object,
    required: true,
  },
})

const handleTicketClick = (ticketId) => {
  ticketStore.fetchTicketDetails(ticketId).then(() => {
    router.push('/ticket')
    callWindowStore.minimizeWindow()
  })
}
</script>

<template>
  <div class="ticket-desc-container hover-row" @click="handleTicketClick(ticket.id)">
    <div
      :style="{ flex: 'none', width: '24px', backgroundColor: styles.ticketStatus[ticket.state] }"
    ></div>
    <v-card variant="text" class="flex-grow-1">
      <v-card-title class="pa-0">
        <div class="d-flex ga-6 align-center">
          <span class="page-text-title">{{ ticket.address }}</span>
          <icon-block
            icon="mdi-clock-outline"
            :iconColor="styles.colors.darkGray"
          >
            {{ ticket.time }}
          </icon-block>
        </div>
      </v-card-title>
      <v-card-text class="pa-0">
        <p class="page-text mt-4">{{ ticket.desc }}</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<style lang="scss" scoped>

.ticket-desc-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.page-text-title {
  font-size: 16px;
  line-height: 19px;
  font-weight: 700;
  color: rgb(var(--v-theme-brandBlack));
}

.page-text {
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
}

.hover-row {
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgb(var(--v-theme-brandLight));
    cursor: pointer;
  }
}

</style>
